import TopCompaniesActions from './TopCompaniesActions';

export default TopCompaniesActions;
